<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
*/

defineProps<{
    menu: any[]
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
*/

const router = useRouter()

const expandedMenus = ref(new Set())

/**
 *
 *  Life cicle events
 *
 *
*/

/**
 *
 *  Functions section
 *
 *
*/
const isMenuExpanded = (menuItem: any) => {
    return expandedMenus.value.has(menuItem.title)
}

const toggleSubmenu = (menuItem: any) => {
    if (expandedMenus.value.has(menuItem.title)) {
        expandedMenus.value.delete(menuItem.title)
    } else {
        expandedMenus.value.add(menuItem.title)
    }
}

const handleClick = (menuItem: any) => {
    if (menuItem.children && menuItem.children.length > 0) {
        toggleSubmenu(menuItem)
    }
    if (menuItem.route) {
        router.push(menuItem.route)
    }
}

const isActive = (menuItem: any) => {
    return router.currentRoute.value.path === menuItem.route || menuItem.children?.some((child: any) => isActive(child))
}
</script>

<template>
    <template v-for="menuItem in menu">
        <div class="tw-w-full">
            <div :class="`tw-relative menuItem-container tw-cursor-pointer tw-flex tw-px-4 tw-justify-between tw-gap-4 tw-py-1 ${isActive(menuItem) ? 'menuItem-active' : ''}`" @click="handleClick(menuItem)">
                <div class="tw-flex tw-items-center tw-gap-4">
                    <q-icon v-if="menuItem.icon" :name="menuItem.icon" size="24px" :class="`${isActive(menuItem) ? 'tw-text-adminPrimary-200' : 'tw-text-adminAccent-200'}`" />
                    <span :class="`${isActive(menuItem) ? 'tw-text-adminPrimary-200' : 'tw-text-adminAccent-200'}`">{{ $t(menuItem.title) }}</span>
                </div>
                <q-icon v-if="menuItem.children && menuItem.children.length > 0" name="sym_o_chevron_right" size="24px" :class="`${isActive(menuItem) ? 'tw-text-adminPrimary-200' : 'tw-text-adminAccent-200'} menuItem-dropdown-icon ${isMenuExpanded(menuItem) ? 'tw-rotate-90' : ''}`" />
            </div>
            <template v-if="menuItem.children && menuItem.children.length > 0">
                <div v-show="isMenuExpanded(menuItem)" :class="`${isMenuExpanded(menuItem) ? 'submenuItem-expanded' : ''} submenuItem-container tw-bg-adminPrimary-300 tw-my-auto tw-flex tw-flex-col tw-w-full`">
                    <template v-for="item in menuItem.children">
                        <div :class="`tw-relative tw-w-full ${isActive(item) ? 'submenuItem-active' : ''}`">
                            <div :class="`tw-flex tw-items-center tw-gap-4 tw-py-1 tw-px-4 tw-w-full tw-cursor-pointer submenuItem-content`" @click.stop="handleClick(item)">
                                <q-icon v-if="item.icon" :name="item.icon" size="24px" class="tw-text-adminAccent-200" />
                                <span class="tw-text-adminAccent-200">{{ $t(item.title) }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </template>
</template>
<style scoped>
.menuItem-active::before, .submenuItem-active::before{
    content: '';
    @apply tw-absolute -tw-right-[10px] tw-top-0 tw-bottom-0 tw-my-auto tw-w-[20px] tw-h-[20px] tw-rotate-45 tw-bg-adminAccent;
}

.menuItem-container:has(~ .submenuItem-expanded)::before,
.menuItem-active:has(~ :hover)::before{
    @apply tw-hidden;
}

.menuItem-container:hover, .submenuItem-content:hover {
    @apply tw-bg-adminAccent-400;
}

.submenuItem-content {
    animation: translateToRight .5s;
}

@keyframes translateToRight {
    from {
        transform: translateX(-30%);
    }
    to {
        transform: translateX(0);
    }
}
</style>